import { SET_DESCRIPTION_ERROR } from '../actions/actionTypes';

const initialState = {
  descriptionError: false,
};

const descriptionError = (state, action) => {
  return {
    ...state,
    descriptionError: action.payload,
  };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DESCRIPTION_ERROR:
      return descriptionError(state, action);
    default:
      return state;
  }
};

export default reducer;
